import { getProgramDisplayName } from './cmsPrograms';

const asEnrollmentList = enrollments => (Array.isArray(enrollments) ? enrollments : Object.values(enrollments || {}));

export const getKitEnrollmentUsage = (kitId, enrollments) =>
  Array.from(
    new Set(
      asEnrollmentList(enrollments)
        .filter(enrollment => (enrollment.kitUnguessableId || enrollment.kit_id) === kitId)
        .map(enrollment => {
          const program = getProgramDisplayName(enrollment.program, enrollment.subprogram) || enrollment.program;
          return [program, enrollment.conditionTitle].filter(Boolean).join(' - ');
        })
        .filter(Boolean),
    ),
  );

export const getKitOption = (kit, enrollments, { usageFirst = false } = {}) => {
  const usage = getKitEnrollmentUsage(kit.id, enrollments);
  const kitLabel = `${kit.id}${kit.name ? ` (${kit.name})` : ''}`;
  return {
    label:
      usageFirst && usage.length
        ? `${usage.join(', ')} — ${kitLabel}`
        : `${kitLabel}${usage.length ? ` — ${usage.join(', ')}` : ''}`,
    value: kit.id,
    name: kit.name,
  };
};

export const getKitOptions = (kits, enrollments) => (kits || []).map(kit => getKitOption(kit, enrollments));
